import copy from './profileCopy.json';
export const profileWords =
  (locale) =>
  (key, values = {}) =>
    (copy[locale]?.[key] ?? copy.ko[key] ?? key).replace(/\{\{(\w+)\}\}/g, (_, name) =>
      String(values[name] ?? ''),
    );
export const profileAlbumKey = (item) =>
  String(item.album.id || item.album.slug || item.album.sourceId);
export function profileConnections(target = [], viewer = []) {
  const mine = new Map(viewer.map((item) => [profileAlbumKey(item), item]));
  return {
    shared: target.filter(
      (item) =>
        item.review.rating >= 4 && (mine.get(profileAlbumKey(item))?.review.rating ?? 0) >= 4,
    ),
    discoveries: target.filter(
      (item) => item.review.rating >= 4 && !mine.has(profileAlbumKey(item)),
    ),
    divergent: target
      .filter(
        (item) =>
          mine.has(profileAlbumKey(item)) &&
          Math.abs(mine.get(profileAlbumKey(item)).review.rating - item.review.rating) >= 1.5,
      )
      .sort(
        (a, b) =>
          Math.abs(mine.get(profileAlbumKey(b)).review.rating - b.review.rating) -
          Math.abs(mine.get(profileAlbumKey(a)).review.rating - a.review.rating),
      )
      .slice(0, 2)
      .map((item) => ({ item, mine: mine.get(profileAlbumKey(item)).review.rating })),
  };
}
